<template>
  <div class="orderPayment">
    <van-form label-width="110px">
      <van-field
        v-model="subData.buyer_name"
        readonly
        @click="toBuyerList"
        name="buyer_name"
        label="客户"
        placeholder="请选择客户"
        input-align="right"
        right-icon="arrow"
      />
      <van-field
        v-model="subData.receivables"
        readonly
        name="receivables"
        label="应退(元)"
        type="number"
        placeholder="请输入应收金额"
        input-align="right"
      />
      <div class="discount">
        <div class="discount_btn">
          <span :class="subData.receivables_type == 1?'active':''" @click="subData.receivables_type = 1;changeDiscount()" >少退</span>
          <span :class="subData.receivables_type == 2?'active':''" @click="subData.receivables_type = 2;changeDiscount()" >多退</span>
        </div>
        <div class="discount_input">
          <KeyBoardInput v-model="subData.discount" :k_placeholder="0" :k_decimal="2" @input="changeDiscount">
            <template slot="input_left">
            </template>
            <template slot="input_right">
              <div class="input_right">元</div>
            </template>
          </KeyBoardInput>
        </div>
      </div>
      <div class="discount">
        <div class="discount_input" style="border-color:transparent;padding-left:0">
          <KeyBoardInput v-model="subData.payment" :k_readonly="true" :k_isValueZero="true" :k_decimal="2">
            <template slot="input_left">
              <div class="input_left">实退</div>
            </template>
            <template slot="input_right">
              <div class="input_right">元</div>
            </template>
          </KeyBoardInput>
        </div>
      </div>
      <van-field name="checkboxGroup" label="退款方式" class="check_box_payment">
        <template #input>
          <div class="pay_type_box">
            <span v-for="(item,index) in pay_type_list" :key="index" :class="subData.pay_type == item.value?'active':''" @click="changePayType(item.value)">
              <img :src="item.icon" alt="">
              {{item.name}}</span>
          </div>
        </template>
      </van-field>
      <van-field
        v-model="subData.remarks"
        rows="1"
        :autosize=" { maxHeight: 100, minHeight: 30 }"
        label="备注"
        type="textarea"
        label-width="50"
        maxlength="30"
        show-word-limit
      />
      <div style="margin: 16px;">
        <van-button style="font-size:0.36rem" round block type="info" @click="onSubmit" color="#31b158">结 算</van-button>
      </div>
      <div style="height:1rem"></div>
    </van-form>
  </div>
</template>

<script>
import KeyBoardInput from "@/components/KeyBoardInput";
import { longtimestampToDate } from "@/utils/timestamp";
import { order_pay ,shopCar_delete} from "@/api/work/order/openOrder";

import Cookies from "@/utils/Cookies";
export default {
  name: "orderPayment",
  components:{
    KeyBoardInput
  },
  data() {
    return {
      pay_type_list: [
        { value: 1, name: "现金", icon:require("@/assets/img/work/open_order/order/pay_rmb.png")},
        { value: 2, name: "支付宝", icon:require("@/assets/img/work/open_order/order/pay_zfb.png")},
        { value: 3, name: "微信", icon:require("@/assets/img/work/open_order/order/pay_wx.png")},
        { value: 4, name: "银行卡", icon:require("@/assets/img/work/open_order/order/pay_yhk.png")},
      ],
      subData: {
        order_sn: "",
        buyer_id: "1",
        buyer_name: "临时客户",
        receivables: "",
        receivables_type: 1, //1优惠，2多收
        discount: "",
        payment: "",
        pay_type: 1,
        goods: "",
        remarks:''
      },
      total_goods_amount: 0, // 计算出来的 总的订单金额
    };
  },
  created() {
    // 返回地址
    this.$navigation.on("back", (to, from) => {
      if (
        from.route.name == "manage_buyer_buyerManage" &&
        from.route.meta.backData
      ) {
        var data = from.route.meta.backData;
        this.subData.new_buyer_id = data.id;
        this.subData.buyer_name = data.name;
      }
    });
    // 判断是开单结算还是改单结算 type == 1 开单, type == 2 改单, type == 3 补单
    if(this.$route.query.type == 1){
      var item = JSON.parse(decodeURI(this.$route.query.item));
      this.computeTotal(item);
      this.subData.buyer_name = item.buyer_name;
      this.subData.buyer_id = item.buyer_id;
      this.subData.new_buyer_id = item.buyer_id;
      this.subData.goods = JSON.stringify(item.order_goods)
      this.subData.receivables = Math.abs(this.total_goods_amount).toFixed(2);
      this.subData.payment = Math.abs(this.total_goods_amount).toFixed(2);
    }else if(this.$route.query.type == 2){
      var item = JSON.parse(decodeURI(this.$route.query.item));
      this.computeTotal(item);
      this.subData.order_sn = this.$route.query.order_sn;
      this.subData.buyer_name = item.buyer_name;
      this.subData.buyer_id = item.buyer_id;
      this.subData.goods = JSON.stringify(item.order_goods)
      this.subData.receivables = this.total_goods_amount;
    }
  },
  mounted() {},
  methods: {
    // 去选择买家
    toBuyerList() {
      this.$router.push({
        path: "/manage/buyer/buyerManage",
        query: {
          use_type: 1
        }
      });
    },

    // 提交数据
    onSubmit() {
      this.subData.discount=this.subData.discount?this.subData.discount:0;
      if (!this.subData.buyer_id) { this.$toast("请选择客户！"); return false; }
      if(this.subData.receivables_type == 1 && this.subData.discount-0 > this.subData.receivables-0){
        this.$toast("少退金额超出！");return false;
      }
      // if ( this.subData.receivables - payment + (this.subData.receivables_type == 1 ? -this.subData.discount : +this.subData.discount) < 0 ) {this.$toast("实收金额超出！");return false;}
      // if(payment == 0){ this.subData.pay_type = -1 }
      if (!this.subData.pay_type) {
        this.$toast("请选择支付方式！");
        return false;
      }
      let obj=JSON.parse(JSON.stringify(this.subData));
      obj.receivables= -this.subData.receivables 
      obj.payment= -this.subData.payment 
      // 判断多收还是优惠  优惠变负数
      if(obj.receivables_type == 2){
        obj.discount = -obj.discount
      }
      delete obj.receivables_type
      order_pay(obj).then(res => {
        if (!this.subData.order_sn) {
          new Audio('http://tts.baidu.com/text2audio?cuid=baiduid&lan=zh&ctp=1&pdt=311&tex=退款'+-obj.payment+'元').play();
          this.$toast.success("退款成功!");
          setTimeout(()=>{
            this.$router.go(-1);
          },1000)
        } else {
          this.$router.go(-2);
          this.$toast.success(res.message);
        }
      });
    },
    // 计算总价
    computeTotal(order_detail) {
      var goods = order_detail.order_goods;
      var amount = 0;
      for (let i = 0; i < goods.length; i++) {
        const item = goods[i];
        if (item.goods_type == 1) {
          if (item.bale == 1) {
            amount += item.price * item.num;
          } else {
            amount += item.price * item.weight;
          }
        } else if (item.goods_type == 2) {
          amount += item.price * item.num;
        }
      }
      this.total_goods_amount = amount.toFixed(2);
    },
    
    // 输入
    changeDiscount() {
      let discount = 0;
      if (this.subData.discount) {
        discount = this.subData.receivables_type == 1 ? -this.subData.discount : +this.subData.discount;
      } else {
        this.subData.discount = "";
      }
      this.subData.payment = Number((this.subData.receivables - 0 + discount)<0?0:(this.subData.receivables - 0 + discount)).toFixed(2);
    },

    // 切换支付方式
    changePayType(value){
      this.subData.pay_type = value
    }
  }
};
</script>

<style lang="less" scoped>
.orderPayment {
  position: relative;
  min-height: calc(100vh - 0.88rem);
  background-color: #fff;
  .discount {
    position: relative;
    padding: 0.2rem 0.3rem 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .discount_btn {
      position: absolute;
      z-index: 3;
      // width: 2.7rem;
      font-size: 0.3rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border: 0.02rem solid #31b158;
      margin-left: 0.15rem;
      border-radius: 0.35rem;
      box-sizing: border-box;
      background-color: #eee;
      padding: 0.04rem;
      span {
        display: inline-block;
        line-height: 0.6rem;
        // border: 0.02rem solid #31b158;
        // box-shadow:  0 0 0.1rem 0.05rem #eee;
        // background-color: #eee;
        border-radius: 0.1rem;
        border-radius: 0.3rem;
        padding: 0 0.3rem;
        &:nth-child(2){
          margin-left: -0.1rem;
        }
        &.active {
          background: #31b158;
          color: #fff;
        }
        &.zhengdan{
          width: 100%;
          color: #31b158;
          color: #fff;
          // border: none;
          // font-size: 0.28rem;
          text-align: center;
          // padding: 0;
        }
      }
    }
    .discount_input {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 0.32rem;
      line-height: 0.8rem;
      border: solid 0.02rem #31b158;
      border: solid 0.02rem #ccc;
      border-radius: 0.1rem;
      padding-right: 0.2rem;
      padding-left: 0.2rem;
      box-sizing: border-box;
      input {
        width: 92%;
        border-radius: 0.1rem;
        line-height: 0.8rem;
        font-size: 0.32rem;
        box-sizing: border-box;
        padding: 0 0.1rem;
        text-align: right;
      }
    }
    .credit_tip{
      position: absolute;
      z-index: 4;
      right: 0.3rem;
      bottom: -0.5rem;
      color:#f00;
      text-align:right;
      font-size:0.32rem
    }
  }
  .pay_type_box{
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;
    span {
      width: 49%;
      box-sizing: border-box;
      line-height: 0.8rem;
      border: 0.05rem solid #f1f1f1;
      // box-shadow:  0 0 0.1rem 0.05rem #eee;
      background-color: #f1f1f1;
      border-radius: 0.1rem;
      padding: 0 0.3rem;
      text-align: center;
      // margin-right: 0.2rem;
      margin-bottom: 0.2rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 0.3rem;
      &.active {
        // background: #31b158;
        border: 0.05rem solid #31b158;
        // color: #fff;
      }
      img{
        width: 0.5rem;
      }
    }
  }
}
</style>

<style lang="less">
.check_box_payment {
  flex-wrap: wrap;
  flex: auto;
  .van-field__value {
    margin-top: 10px;
    width: 100%;
    flex: auto;
  }
}
</style>